
export class EzSaleRequest {
  public nric?: string;
  public basicSumAssured?: number;
  public bsComponentCode?: string;
  public criticalIllnessSumAssured?: number;
  public ciComponentCode?: string;
  public personalAccidentSumAssured?: number;
  public paComponentCode?: string;
  public cntType?: string;
  public campaignCode?: string;
  constructor(initial: any) {
    Object.assign(this, initial);
  }
}